import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from '@angular/core';

import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { HttpService } from '../../../services/http.service';

import { UserAccountDTO } from '../../../classes/user-account.dto';

import { StorageService } from '../../../services/storage.service';

import { Subscription } from 'rxjs';

import { GtmService } from '../../../services/gtm.service';
import { AriaAutocompleteFieldComponent, AriaFieldOption } from '../../shared';




@Component({

  selector: 'app-modal-with-one-select',

  imports: [

    TranslateModule,

    ReactiveFormsModule,

    AriaAutocompleteFieldComponent,

  ],

  templateUrl: './modal-with-one-select.component.html',

  styleUrls: ['./modal-with-one-select.component.scss'],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})

export class ModalWithOneSelectComponent implements OnInit, OnDestroy {

  /* TODO Rendere dinamica se possibile e se serve. */

  readonly nzModalData = inject(NZ_MODAL_DATA);

  selectControl?: FormControl;

  languages: { texts: Array<string>; values: Array<string> } = {

    texts: [

      'Italiano',

      'Inglese',

      'Francese',

      'Spagnolo',

      'Partoghese',

      'Tedesco',

      'Greco',

      'Russo',

      'Arabo',

      'Cinese',

    ],

    values: ['it', 'en', 'fr', 'es', 'pt', 'de', 'el', 'ru', 'ar', 'zh'],

  };

  languageOptions: AriaFieldOption[] = [];

  subscription: Array<Subscription> = [];

  constructor(

    private modalRef: NzModalRef,

    private http: HttpService,

    private storage: StorageService,

    private cdr: ChangeDetectorRef,

    private gtmService: GtmService

  ) {}

  ngOnInit() {

    this.languageOptions = this.languages.values.map((value, index) => ({

      value,

      label: this.languages.texts[index] ?? value,

    }));

    this.selectControl = new FormControl(null, Validators.required);

    this.checkValidationControl();

  }

  protected exit(): void {

    this.modalRef.close();

  }

  private checkValidationControl(): void {

    this.subscription.push(

      this.selectControl!.valueChanges.subscribe(() => {

        this.cdr.detectChanges();

      })

    );

  }

  protected download(): void {

    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;

    this.subscription.push(

      this.http

        .getMedicalPassport(userData.individualId, this.selectControl?.value)

        .subscribe((html: string) => {

          this.openHtml(html);

        })

    );

  }

  private openHtml(html: string): void {

    const language = this.selectControl?.value;

    console.log('GTM event: health_passport', language);

    this.gtmService.pushHealthDataEvent('health_passport', language);

    const blob = new Blob([html], { type: 'text/html' });

    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');

    this.modalRef.close();

  }

  ngOnDestroy(): void {

    this.subscription.forEach((subscription: Subscription) => {

      subscription.unsubscribe();

    });

  }

}
 